import React, { Component } from "react";
import apiService from "../../Services/apiServices";
import Select from "react-select";
import moment from "moment";
moment().format();

class RecalculateAvgPrice extends Component {
  constructor(props) {
    super(props);

    this.state = {
      date: moment().locale("en").format("YYYY-MM-DD"),
      items: [],
      itemId: 0,
    };

    this.recalculate = this.recalculate.bind(this);
  }

  componentDidMount() {
    apiService()
      .query("getItems")
      .then((data) => {
        if (data.success) {
          this.setState({ items: data.data });
        } else {
          console.log("Error:" + data.errorMessage);
        }
      });
  }

  handleChange = (itemId) => {
    this.setState({ itemId });
  };
  onFieldChange = (e) => {
    this.setState({
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };

  recalculate = () => {
    var date = this.state.date;
    var itemId =
      this.state.itemId.value === undefined ? 0 : this.state.itemId.value;
    var params = `date=${date}&itemId=${itemId}`;

    if (confirm("A jeni te sigurt qe deshironi ta rikalkuloni bazen?")) {
      // Save it!
      apiService()
        .query("Recalculate", params)
        .then((response) => {
          if (response.success) {
            alert("Rikalkulimi u kry me sukses!");
          } else {
            alert("Ka ndodhe nje gabim!" + response.error);
          }
        });
    }
  };

  render() {
    const { items, date } = this.state;
    const stateOptions = items.map((item, index) => ({
      value: item.id,
      label: item.itemName,
    }));
    return (
      <div className="container-fluid px-2 mt-3">
        <div className="card border-left-primary shadow h-100 py-2 ">
          <div className="card-body">
            <h3>Rikalkulimi i cmimit kushtues te artikujve</h3>
            <p>
              Zgjidh daten dhe kliko te butoni <b>Rikalkulo</b> per te filluar
              rikalkulimi i cmimit kushtues per artikujt e shitur
            </p>
            <div className="row no-gutters align-items-center">
              <div className="col mr-2 row">
                <div className="col-lg-3 form-group">
                  <label className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                    Data
                  </label>
                  <input
                    name="date"
                    value={date}
                    className="form-control"
                    onChange={this.onFieldChange}
                    type="date"
                  />
                </div>
                <div className="col-lg-6 form-group">
                  <label className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                    Artikujt
                  </label>
                  <Select
                    name="itemId"
                    placeholder="Zgjedh"
                    value={this.state.itemId}
                    onChange={this.handleChange.bind(this)}
                    options={stateOptions}
                  />
                  {/* <select
                    name="itemId"
                    onChange={this.onFieldChange.bind(this)}
                    value={this.state.itemId}
                    className="form-control form-control"
                  >
                    <option value="0"> Zgjedh Artikullin</option>
                    {items.map((item, key) => (
                      <option key={item.id.toString()} value={item.id}>
                        {item.itemName}
                      </option>
                    ))}
                  </select> */}
                </div>
              </div>
              <div className="col-auto">
                <button className="btn btn-primary" onClick={this.recalculate}>
                  Rikalkulo
                  {/* <i className="fas fa-calculator fa-2x " /> */}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RecalculateAvgPrice;
